import Enquires from './Subscriptions';
import AuthRole from 'layouts/Dashboard/AuthRole';

const routes = [

  { path: 'subscriptions', element: <AuthRole role="administrator" isPage><Enquires /></AuthRole>},
]

  export default routes;